<template>
  <div
    class="3xl:bg-bottom flex h-screen flex-col bg-[url('/src/components/Brand/DefaultLayout/BackgroundImage.svg')] bg-cover bg-no-repeat pb-4"
  >
    <div class="bg-semantic-warning-orange-400 mb-4 h-11 w-full p-2.5 text-center font-medium">
      {{ t('vendors.adminDB') }}
    </div>
    <div class="flex min-h-0 grow flex-col overflow-y-auto md:px-4">
      <div
        id="layout-container"
        class="bg-background-light-200 flex min-h-0 w-full grow flex-col overflow-y-auto md:rounded-2xl"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import i18n from '@/plugins/vue-i18n';

const { t } = i18n.global;
</script>
